import { IChecklistTask, IChecklistTaskDto } from '@features/Checklist/model/types';

import { generateChecklistClientId } from './generateChecklistClientId';

export const hydrateChecklistItems = (
    items: IChecklistTaskDto[],
    prevItems: IChecklistTask[] = []
): IChecklistTask[] => {
    const matchedPrevClientIds = new Set<string>();

    return items.map((item) => {
        const persistedMatch = prevItems.find(
            (prevItem) => prevItem.id === item.id && !matchedPrevClientIds.has(prevItem.clientId)
        );

        if (persistedMatch) {
            matchedPrevClientIds.add(persistedMatch.clientId);

            return {
                ...item,
                clientId: persistedMatch.clientId,
            };
        }

        const optimisticMatch = prevItems.find(
            (prevItem) =>
                prevItem.id === undefined &&
                prevItem.text === item.text &&
                prevItem.sortOrder === item.sortOrder &&
                prevItem.isChecked === item.isChecked &&
                !matchedPrevClientIds.has(prevItem.clientId)
        );

        if (optimisticMatch) {
            matchedPrevClientIds.add(optimisticMatch.clientId);

            return {
                ...item,
                clientId: optimisticMatch.clientId,
            };
        }

        return {
            ...item,
            clientId: generateChecklistClientId(),
        };
    });
};
